/* eslint-env jquery, browser, es6 */
/* eslint-disable no-alert */
import $ from 'jquery';
import {
  activateSpinner,
  deactivateSpinner,
  endpoint,
  isiOS,
  urlParams,
  validateEmail,
} from './shared';
import '../scss/main.scss';

$(() => {
  const steps = [0, 5, 10, 25, 50];
  const firstStepOffset = 10;
  const stepDiff = 20;

  function updateProgress(count) {
    let progressPercent = 0;
    let stepPos = 1;
    if (count >= steps[steps.length - 1]) {
      $('.reward-amount').addClass('earned');
      progressPercent = 100;
    } else {
      while (stepPos < steps.length) {
        if (count < steps[stepPos]) {
          if (stepPos <= 1) {
            progressPercent = count / steps[stepPos] * (firstStepOffset + stepDiff);
          } else {
            $('.amount-5').addClass('earned');
            const delta = (count - steps[stepPos - 1])
              / (steps[stepPos] - steps[stepPos - 1]) * stepDiff;
            progressPercent = delta + (stepPos - 1) * stepDiff + firstStepOffset;
          }
          break;
        }
        $(`.amount-${steps[stepPos]}`).addClass('earned');
        stepPos += 1;
      }
    }

    $('.progress-no-mobile .progress-filled').css('width', `${progressPercent}%`);
    $('.progress-mobile .progress-filled').css('height', `${progressPercent}%`);
  }

  function updateReferralCount(count) {
    $('.num-friends').text(count);
    if (count !== 0) {
      $('.yet').remove();
    }
    updateProgress(count);
  }

  function setReferState() {
    $('body').removeClass('state-email').addClass('state-refer');
  }

  function updateReferralLink(referralCode) {
    $('.referral-link').val(`https://newsletter.yestheory.com/?ref=${referralCode}`);
  }

  function updateQueryParams(email) {
    window.history.replaceState({}, 'foo', `${window.location.origin}?email=${email}`);
  }

  function getReferralStatsSuccess(res) {
    deactivateSpinner();
    updateReferralCount(res.referral_count);
    updateReferralLink(res.referral_code);
    setReferState();
  }

  function getReferralStatsError(err) {
    deactivateSpinner();
    alert(err.responseText);
  }

  function getReferralStats() {
    const email = $('.email-input').val().toLowerCase().trim();
    if (!validateEmail(email)) {
      alert('Invalid Email, please enter a valid email address.');
      return;
    }
    updateQueryParams(email);
    activateSpinner();
    $.get(`${endpoint}/referrals?email=${email}`)
      .done(getReferralStatsSuccess)
      .fail(getReferralStatsError);
  }

  function iosCopyToClipboard() {
    const el = $('.referral-link')[0];
    const oldContentEditable = el.contentEditable;
    const oldReadOnly = el.readOnly;
    const range = document.createRange();

    el.contentEditable = true;
    el.readOnly = false;

    range.selectNodeContents(el);

    const s = window.getSelection();
    s.removeAllRanges();
    s.addRange(range);

    el.setSelectionRange(0, 999999);

    el.contentEditable = oldContentEditable;
    el.readOnly = oldReadOnly;

    document.execCommand('copy');
  }

  function setupClicks() {
    $('form').on('submit', (e) => {
      e.preventDefault();
      getReferralStats();
    });
    $('.referral-link').on('click', () => {
      if (isiOS()) {
        iosCopyToClipboard();
      } else {
        const copyText = document.querySelector('.referral-link');
        copyText.select();
        document.execCommand('copy');
      }
      $('.link-copied').removeClass('hidden');
    });
  }

  function checkReferralFromUrl() {
    const { ref, email } = urlParams;
    if (email) {
      activateSpinner();
      $.get(`${endpoint}/referrals?email=${email}`)
        .done(getReferralStatsSuccess)
        .fail(getReferralStatsError);
    } else if (ref) {
      activateSpinner();
      $.get(`${endpoint}/referrals?referralCode=${ref}`)
        .done(getReferralStatsSuccess)
        .fail(getReferralStatsError);
    }
  }

  setupClicks();
  checkReferralFromUrl();
});
